import QRCodeSVG from '../../../elements/QRCode';
import React from 'react';
import { Align } from '../../../modules/ReceiptLayouts/Model';
export const BlockQR = ({ ticket, align }) => {
    return (React.createElement("div", { style: { width: '100%', display: 'grid', justifyContent: align || defaultProps.align } },
        React.createElement("span", null, `${ticket.numero}`),
        React.createElement("div", { style: { width: '100%', display: 'grid', justifyContent: align || defaultProps.align } },
            React.createElement(QRCodeSVG, { value: ticket.numero, size: 100, level: 'H' }))));
};
const defaultProps = {
    align: Align.Center
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockQR.tsx
// module id = 518
// module chunks = 0